// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2vHYp","title":"FrontImage_title__azzBx"};